import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useBrands } from "@/data/hooks";
import { useLanguage } from "@/i18n/LanguageContext";
import { FadeUp, Stagger, StaggerItem } from "@/components/Reveal";
import { BrandMark } from "@/components/BrandMarks";

export default function BrandsIndex() {
 const BRANDS = useBrands();
 const { locale } = useLanguage();
 const l = (fr, en, pt) => locale === "en" ? en : locale === "pt" ? pt : fr;
 return (
 <div data-testid="page-brands">
 <section className="border-b border-nanda-line">
 <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 pt-24 md:pt-40 pb-20 md:pb-28 grid grid-cols-1 md:grid-cols-12 gap-10">
 <FadeUp className="md:col-span-4">
 <div className="label-overline text-nanda-muted">{l("Les Maisons", "The Houses", "As Casas")}</div>
 </FadeUp>
 <FadeUp delay={0.1} className="md:col-span-8">
 <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl text-balance leading-[1.0]">{l("Quatre Maisons. Une même exigence.", "Four Houses. One same rigour.", "Quatro Casas. Uma mesma exigência.")}</h1>
 <p className="mt-10 max-w-2xl text-nanda-inkSoft text-base md:text-lg leading-relaxed">
 {l(
 "De l'énergie aux produits, de la table à la peau, de la transmission à l'orientation, découvrez les quatre expressions du NANDA SÁ.",
 "From energy to products, from table to skin, from transmission to guidance, discover the four expressions of the NANDA SÁ.",
 "Da energia aos produtos, da mesa à pele, da transmissão à orientação, descubra as quatro expressões do NANDA SÁ."
 )}
 </p>
 </FadeUp>
 </div>
 </section>

 <section className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 py-16 md:py-24">
 <Stagger className="space-y-px bg-nanda-line border border-nanda-line">
 {BRANDS.map((b, idx) => (
 <StaggerItem key={b.slug} className="bg-nanda-bg">
 <Link to={`/marques/${b.slug}`} data-testid={`brand-row-${b.slug}`} className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-center p-6 md:p-10 hover:bg-nanda-bgAlt transition-colors duration-500">
 <div className={`md:col-span-4 aspect-[5/4] md:aspect-[5/3] overflow-hidden ${b.heroStyle === "product" ? "bg-[#F5EDE2] flex items-center justify-center" : ""}`}>
 <img src={b.image} alt={b.name} loading="lazy" className={`h-full w-full transition-transform duration-[1400ms] ease-out group-hover:scale-105 ${b.heroStyle === "product" ? "object-contain p-4" : "object-cover"}`} />
 </div>
 <div className="md:col-span-1 label-overline text-nanda-muted">0{idx + 1}</div>
 <div className="md:col-span-5">
 <div className="flex items-center gap-4 mb-3">
 <BrandMark slug={b.slug} size={40} className="text-nanda-ink shrink-0" />
 <div className="font-serif text-3xl md:text-4xl lg:text-5xl text-nanda-ink leading-tight">{b.name}</div>
 </div>
 <div className="label-overline text-nanda-muted">{b.category}</div>
 <p className="mt-5 text-nanda-inkSoft text-base max-w-md">{b.tagline}</p>
 </div>
 <div className="md:col-span-2 md:text-right">
 <span className="inline-flex items-center gap-2 label-overline text-nanda-ink group-hover:translate-x-1 transition-transform duration-500">{l("Découvrir", "Discover", "Descobrir")} <ArrowUpRight size={14} strokeWidth={1.5} /></span>
 </div>
 </Link>
 </StaggerItem>
 ))}
 </Stagger>
 </section>
 </div>
 );
}
